import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function Announcement(props) {

    const [annContent, setAnnContent] = useState(props.content);

    useEffect(() => {
        if (props.content && props.content.length > 200 && props.fullstring === "false") {
            setAnnContent(props.content.substring(0, 200) + "...");
        } else {
            setAnnContent(props.content);
        }
    }, [props.content]);

    return (
      <>
        <div className="onea_block">
            <h3 className='onea_title'>
                {props.link !== "false" ? (
                    <Link to={props.link} className='onea_title onea_title_link'>
                        {props.title}
                    </Link>
                    ) : (
                    props.title
                )}
                
                
            </h3>
            <p className='onea_date'>
                <span className="fa-regular fa-calendar"></span>&nbsp;{props.date}
            </p>

            <p className='onea_content'>
                {annContent}
            </p>

            {props.last === "false" && <div className="onea_hr"></div>}
            
        </div>
      </>
    );
}

export default Announcement;

